module.exports = __webpack_public_path__ + "images/play_large@1x.png?250c10be";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_large@1x.png
// module id = 677
// module chunks = 7